import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const AdminLogin = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleLogin = async () => {
    setError("");

    try {
      const res = await fetch(`${API_BASE}/api/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const json = await res.json();

      if (!res.ok || !json.success) {
        setError(json.message || "Login failed");
        return;
      }

      localStorage.setItem("access", json?.data?.access);
      localStorage.setItem("refresh", json?.data?.refresh);
      localStorage.setItem("admin_logged_in", "true");

      navigate("/admin-dashboard");
    } catch (err) {
      setError("Network error. Try again.");
    }
  };

  return (
    <div style={{ padding: 40, textAlign: "center" }}>
      <h2>Admin Login</h2>

      <div className="signin-form">
        <input
          type="email"
          placeholder="Admin Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={{
            padding: 10,
            width: 250,
            marginTop: 20,
            borderRadius: 8,
            border: "1px solid #ccc",
          }}
        />


        <input
          type="password"
          placeholder="Admin Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={{
            padding: 10,
            width: 250,
            marginTop: 20,
            borderRadius: 8,
            border: "1px solid #ccc",
          }}
        />



        <button
          onClick={handleLogin}
          style={{
            marginTop: 20,
            padding: "10px 20px",
            borderRadius: 8,
            background: "#111827",
            color: "#fff",
            border: "none",
            cursor: "pointer",
          }}
        >
          Login
        </button>
      </div>
      {error && (
        <p style={{ color: "red", marginTop: 10 }}>{error}</p>
      )}
    </div>
  );
};

export default AdminLogin;
